import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { fmtTRY } from "../../lib/format";

const PERIODS = [["daily", "Günlük"], ["weekly", "Haftalık"], ["monthly", "Aylık"]];
const SOURCE_LABEL = { BIGELDI: "Bigeldi.com", TRENDYOL: "Trendyol", HEPSIBURADA: "Hepsiburada" };

export default function ReportsPage() {
  const [period, setPeriod] = useState("weekly");
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/admin/reports/summary?period=${period}`).then(({ data }) => setData(data)).catch((e) => toast.error(errMsg(e)));
  }, [period]);

  const maxSales = Math.max(1, ...(data?.daily?.map((d) => d.sales) || [1]));

  return (
    <div className="space-y-5" data-testid="admin-reports">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="font-display font-extrabold text-2xl text-white">Raporlar</h1>
        <div className="flex gap-2">
          {PERIODS.map(([v, l]) => (
            <button key={v} onClick={() => setPeriod(v)}
              className={`h-9 px-4 rounded-xl text-xs font-semibold ${period === v ? "bg-blue-600 text-white" : "bg-[#181B20] text-neutral-400 border border-[#272B33] hover:text-white"}`}
              data-testid={`report-period-${v}`}>{l}</button>
          ))}
        </div>
      </div>

      {data && (
        <>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            {[
              ["Ciro", fmtTRY(data.revenue), "report-revenue"],
              ["Sipariş", data.order_count, "report-orders"],
              ["Ortalama Sepet", fmtTRY(data.avg_basket), "report-avg"],
              ["İptal / İade", `%${data.cancel_rate} / %${data.return_rate}`, "report-rates"],
            ].map(([label, value, tid]) => (
              <div key={tid} className="bg-[#181B20] border border-[#272B33] rounded-2xl p-5">
                <p className="text-[11px] uppercase tracking-wider text-neutral-500">{label}</p>
                <p className="text-xl font-display font-extrabold text-white mt-1.5" data-testid={tid}>{value}</p>
              </div>
            ))}
          </div>

          <div className="grid lg:grid-cols-2 gap-4">
            <div className="bg-[#181B20] border border-[#272B33] rounded-2xl p-5">
              <p className="text-sm font-bold text-white mb-4">Kaynak Bazlı Satış</p>
              <div className="space-y-3">
                {Object.entries(data.by_source).map(([src, v]) => (
                  <div key={src} className="flex items-center justify-between" data-testid={`report-source-${src}`}>
                    <span className="text-sm text-neutral-400">{SOURCE_LABEL[src] || src}</span>
                    <span className="text-sm text-white font-semibold">{fmtTRY(v.total)} <span className="text-neutral-500 font-normal">({v.count} sipariş)</span></span>
                  </div>
                ))}
              </div>
            </div>
            <div className="bg-[#181B20] border border-[#272B33] rounded-2xl p-5">
              <p className="text-sm font-bold text-white mb-4">Günlük Satış</p>
              <div className="flex items-end gap-1 h-32">
                {data.daily.map((d) => (
                  <div key={d.date} className="flex-1 flex flex-col items-center gap-1" title={`${d.date}: ${fmtTRY(d.sales)} (${d.orders} sipariş)`}>
                    <div className="w-full bg-blue-600/70 rounded-t" style={{ height: `${Math.max(2, (d.sales / maxSales) * 100)}%` }} />
                    <span className="text-[8px] text-neutral-500">{d.date}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
